import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { isCurrentCardJoker } from '../CardStateHelper';
import { IGameState } from 'State/Game/IGameState';
import { CardState } from 'Prototype/Level/Card/CardState';
import { CardTask } from '../CardTasks';

export default class JokerPreBoosterCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState) {
        return state.levelState.cardsState.inStack.some(cardID => cardID === this.cardID);
    }

    public play(state: IGameState): IGameState {
        const currentCardState = CardStateHelper.getCardState(state, this.cardID);
        if (currentCardState === CardState.IN_STACK && !isCurrentCardJoker(state)) {
            return CardStateHelper.foldStackCard(state, this.cardID);
        }
        return state;
    }

    public onCardDiscarded(state: IGameState): IGameState {
        return this.queueReceivedTask(state);
    }

    private queueReceivedTask(state: IGameState): IGameState {
        return CardStateHelper.updateGameState(
            state,
            CardStateHelper.setStateTaskData(state.levelState.cardsState, {
                task: CardTask.RECEIVE_JOKER_PRE_BOOSTER,
                cards: [this.cardID],
            })
        );
    }
}
